<div class="subscribe-container">
  <!-- Hero section -->
  <section class="hero">
    <div class="hero-content">
      <h1>Szerezd meg a <span>10%-os kuponod</span> most!</h1>
      <p>
        Iratkozz fel, és azonnal elküldjük a <strong>10% kedvezményes kuponodat</strong> QR-kóddal együtt.
        A vásárláskor beolvassuk a kódot, és akár <strong>extra ajándékot</strong> is nyerhetsz –
        például <strong>25%-os kupont</strong> vagy <strong>ajándék cserepes növényt</strong>!
      </p>
    </div>
  </section>

  <!-- Form section -->
  <section class="form-section">
    <div class="form-card">
      <h2>Iratkozz fel most</h2>

      <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
        <div class="input-group">
          <label>Név</label>
          <input
            type="text"
            placeholder="Írd be a neved"
            formControlName="name"
            [class.invalid]="subscribeForm.get('name')?.invalid && subscribeForm.get('name')?.touched"
          />
          <p class="error" *ngIf="subscribeForm.get('name')?.invalid && subscribeForm.get('name')?.touched">
            Név megadása kötelező.
          </p>
        </div>

        <div class="input-group">
          <label>E-mail cím</label>
          <input
            type="email"
            placeholder="Írd be az e-mail címed"
            formControlName="email"
            [class.invalid]="subscribeForm.get('email')?.invalid && subscribeForm.get('email')?.touched"
          />
          <p class="error" *ngIf="subscribeForm.get('email')?.invalid && subscribeForm.get('email')?.touched">
            Érvényes e-mail cím szükséges.
          </p>
        </div>

        <!-- ✅ Checkbox és adatvédelmi link -->
        <div class="consent-group mt-4">
          <label class="checkbox-label">
            <input type="checkbox" formControlName="marketingConsent" />
            <span>
              Szeretnék értesülni az új akciókról és kuponokról.
              <small>(Havonta legfeljebb 1 e-mailt küldünk, csak ha van új ajánlat.)</small>
            </span>
          </label>

          <p class="privacy-note">
            Feliratkozásoddal elfogadod az
            <a routerLink="/privacy-policy" target="_blank" class="text-blue-600 underline">
              Adatvédelmi nyilatkozatot
            </a>.
          </p>
        </div>

        <!--
        <div class="captcha-wrapper">
          <re-captcha
            (resolved)="onCaptchaResolved($event)"
            siteKey="6LcfLScrAAAAAKucDJ8EDamIc9_X4eJt4HkR0ga3"
          ></re-captcha>
        </div>-->

        <button type="submit" [disabled]="isSubmitting || subscribeForm.invalid">
          Kérem a kuponom
        </button>

        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>

        <div *ngIf="isSubmitted" class="success-message">
          🎉 Sikeresen feliratkoztál! Hamarosan érkezik a kuponod!
        </div>
      </form>
    </div>
  </section>

  <!-- Gifts / rewards section -->
  <section class="rewards-section">
    <h2>🎁 Lehetséges ajándékaid</h2>
    <p>Vásárlás után a QR-kód beolvasásával akár ezeket is megnyerheted!</p>

    <hr>

    <div class="rewards-grid">
      <div class="reward-card">
        <img src="assets/images/kupon_10.jpg" alt="10% Kupon" />
        <h3>10% Kupon</h3>
        <p>Garantált kedvezmény minden feliratkozónak!</p>
      </div>

      <div class="reward-card">
        <img src="assets/images/cserepes_orchidea.jpg" alt="Cserepes Orchidea" />
        <h3>Cserepes Orchidea</h3>
        <p>Elegáns orchidea – a szerencsések egyik kedvence!</p>
      </div>

      <div class="reward-card">
        <img src="assets/images/cserepes_noveny.jpg" alt="Mini cserepes növény" />
        <h3>Cserepes Növény</h3>
        <p>Egy különleges ajándék, ami feldobja a napodat.</p>
      </div>

      <div class="reward-card">
        <img src="assets/images/kupon_5000.jpg" alt="25% Kupon" />
        <h3>5000 Ft-os Kupon</h3>
        <p>5000 Ft értékű kupon 25 000 Ft feletti vásárlásra.</p>
      </div>
    </div>
    <hr>
    <p>Vagy akár ennél nagyobb ajándék is a tiéd lehet!</p>
  </section>
</div>
